<template>
  <section class="map-container">
    <div class="content-max-width flex">

      <div
          v-show="view === 'list' || view === null"
          class="locations-list"
          >

        <div class="form">
          <div class="form-field">
            <input type="text" v-model="payload.title" placeholder="Search Store names">
          </div>

          <div class="form-field select">
            <select
                v-model="selected_region_id"
                @change="changeRegion"
                >
              <option :value="0">All Regions</option>
              <option
                  v-for="region of regions"
                  :value="region.id"
                  v-bind:key="region.id"
                  >
                {{ region.title }}
              </option>
            </select>
          </div>
        </div>

        <div class="results">

          <article
              v-for="(store, index) of filteredListWithKeyword"
              :key="index"
              @click="newCoords(store.latitude, store.longitude)"
              >
            <h3>{{ store.title }}</h3>
            <!-- <p>{{ store.company }}</p> -->
            <p><a :href="'tel:' + store.phone"> {{ store.phone }}</a></p>
            <p><a :href="'mailto:' + store.email"> {{ store.email }}</a></p>
            <p><a :href="store.website" target="_blank"> {{ store.website }}</a></p>
            <p>{{ store.address }}</p>
          </article>

        </div>

      </div>

      <app-map
          v-show="view === 'map' || view === null"
          :latitude="center.latitude"
          :longitude="center.longitude"
          :locations="locations"
          :zoomdata="zoom"
          v-on:draggedLatLong="newCoords"
          :maps_api_key="maps_api_key"
          ></app-map>
    </div>

    <div class="buttons-toggle">
      <button @click="switchView('map')" :class="{ 'active' : view === 'map' }">View Map</button>
      <button @click="switchView('list')" :class="{ 'active' : view === 'list' }">List View</button>
    </div>

  </section>
</template>

<script>
  import { orderByDistance } from 'geolib'
  export default {
      components: {
          orderByDistance
      },

      props: {
          regions: Array,
          locations: Array,
          maps_api_key: String
      },

      data() {
          return {
              view: null,
              places: [],
              zoom: 10,
              payload: {
                  title: '',
                  region: 0,
                  latitude: 0,
                  longitude: 0
              },
              center: {
                  latitude: -36.8473374,
                  longitude: 174.7479545
              },
              selected_region_id: 0
          }
      },

      computed: {
          selectedRegion() {
              if (this.selected_region_id !== 0) {
                  return this.regions.find(obj => obj.id === this.selected_region_id)
              } else {
                  return 0
              }
          },

          browserWidth() {
              if (self.innerWidth) {
                  return self.innerWidth;
              }
              if (document.documentElement && document.documentElement.clientWidth) {
                  return document.documentElement.clientWidth;
              }
              if (document.body) {
                  return document.body.clientWidth;
              }
          },

          filteredListWithKeyword() {
              return this.places.filter(post => {
                  return post.title.toLowerCase().includes(this.payload.title.toLowerCase())
              })
          }

      },

      mounted() {
          this.places = this.locations

          if (this.browserWidth >= 767) {
              this.view = null
          } else {
              this.view = 'map'
          }

          if (window.location.search) {
              let url = new URL(window.location.href)
              console.log(url)
              let region = url.searchParams.get('region')
              let title = url.searchParams.get('title')

              if (region) {
                  console.log('reg', region)
                  this.selected_region_id = parseInt(region)
              }
              if (title) {
                  console.log('store', title)
                  this.payload.title = parseInt(title)
              }
              this.changeRegion()
          } else {
              this.loadLocations()
          }
      },
      methods: {
          switchView(view) {
              this.view = view
          },

          clearAll() {
              this.selected_region_id = 0
              this.payload.latitude = 0
              this.payload.longitude = 0
              this.places = this.locations
          },

          newCoords(lat, lng) {
              console.log(lat, lng)
              this.payload.latitude = lat
              this.payload.longitude = lng
              this.zoom = 16
              this.loadLocations()
          },

          changeRegion() {
              if (this.selected_region_id !== 0) {
                  let region = this.regions.find(obj => obj.id === this.selected_region_id)
                  this.center.latitude = region.latitude
                  this.center.longitude = region.longitude
                  this.payload.latitude = 0
                  this.payload.longitude = 0
                  this.zoom = 10
                  this.loadLocations()
              } else {
                  this.filterOptions(this.locations)
              }
          },

          loadLocations() {
              this.$parent.isLoading = true

              let url = '?'
              url += '&region=' + this.selected_region_id
              console.log(url)
              history.pushState(this.payload, '', '/where-to-buy' + url)

              if (this.payload.latitude !== 0 && this.payload.longitude !== 0) {
                  console.log('region', this.payload)
                  /* let center = {
                      latitude: this.payload.latitude,
                      longitude: this.payload.longitude
                  } */
                  this.center.latitude = this.payload.latitude
                  this.center.longitude = this.payload.longitude

                  let sortedCoordinates = orderByDistance(center, this.locations)
                  console.log('sorted', center, sortedCoordinates)
                  this.places = []

                  setTimeout(() => {
                      this.places = sortedCoordinates
                      this.filterOptions(this.places)
                      this.$parent.isLoading = false
                  }, 100)

              } else {
                  this.filterOptions(this.locations)
                  this.$parent.isLoading = false
              }

          },

          filterOptions(list) {
              // only region chosen
              if (this.selected_region_id > 0) {
                  console.log('filter regions')
                  this.places = list.filter(place => place.region_id === this.selected_region_id)
              } else {
                  console.log('filter none')
                  this.places = list
              }
          }
      }
  };
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/locations/Index.vue